import { createContext, useReducer } from 'react'

import { AppQuiz_content_QuizContent } from 'globalTypes'

import { getInitialState, reducer, ReducerState } from '../utilities'

interface ContextProps {
  state: ReducerState
  dispatch: Function
}

export const Context = createContext<ContextProps | undefined>(undefined)
Context.displayName = 'StateContext'

export const Provider = Context.Provider
export const Consumer = Context.Consumer

interface Props {
  children: React.ReactNode | React.ReactNode[]
  content: AppQuiz_content_QuizContent
}

const StateContext = ({ children, content }: Props) => {
  const initialState = getInitialState(content)
  const [state, dispatch] = useReducer<
    (state: ReducerState, action: any) => any
  >(reducer, initialState)

  return <Provider value={{ state, dispatch }}>{children}</Provider>
}

export default StateContext
